import { useLocation } from 'react-router-dom';

export const useRedirectUrl = () => {
  const { pathname, search, hash } = useLocation();

  return pathname + search + hash;
};
